import { createAuthor, deleteAuthor, fetchAuthorList, updateAuthor } from './author.actions';
import { createReducer } from '../../../frontendUtils/redux';
import {
  deleteArrayItemAfterAsyncCall,
  getArrayAfterAsyncCall,
  getArrayAfterAsyncCreateCall,
  updateArrayItemAfterAsyncCall,
} from '../../../frontendUtils/redux/reducers';
import { Author } from '@api/types.generated';

export type AuthorState = Author[];
export const initialState: AuthorState = [];

const authorReducer = createReducer(initialState, {
  [fetchAuthorList.done.type]: (state, action) => getArrayAfterAsyncCall(state, action),
  [createAuthor.done.type]: (state, action) => getArrayAfterAsyncCreateCall(state, action),
  [updateAuthor.done.type]: (state, action) => updateArrayItemAfterAsyncCall(state, action),
  [deleteAuthor.done.type]: (state, action) => deleteArrayItemAfterAsyncCall(state, action),
});

export default authorReducer;
